import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconFileText } from '../components/Icons';

const EContractView = () => {
  const { t } = useLanguage();
  
  const [contracts] = useState([
    {
      id: 1,
      name: 'Makati Condo Unit 301 Lease Agreement',
      status: 'awaitingSignature',
      createdDate: '2024-01-16',
    },
    {
      id: 2,
      name: 'BGC Apartment 201 Lease Agreement',
      status: 'completed',
      createdDate: '2024-01-10',
    },
  ]);

  const templates = [
    {
      id: 1,
      name: t('standardLeaseContract'),
      description: 'Standard lease agreement for residential properties',
    },
    {
      id: 2,
      name: t('shortTermLeaseContract'),
      description: 'Contract for short-term rentals under 6 months',
    },
  ];

  const getStatusBadge = (status) => {
    if (status === 'awaitingSignature') {
      return (
        <span className="px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
          {t('awaitingSignature')}
        </span>
      );
    }
    return (
      <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
        {t('contractCompleted')}
      </span>
    );
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('eContract')}</h1>

      {/* Contract Templates */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold mb-4 flex items-center">
          <IconFileText className="w-6 h-6 mr-2" />
          {t('contractTemplates')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {templates.map((template) => (
            <div key={template.id} className="border border-gray-200 rounded-lg p-4 hover:border-blue-500 transition-colors">
              <h3 className="font-semibold text-gray-900 mb-2">{template.name}</h3>
              <p className="text-sm text-gray-600 mb-3">{template.description}</p>
              <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md text-sm">
                {t('createNewContract')}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Ongoing Contracts */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4">{t('ongoingContracts')}</h2>
        <div className="space-y-4">
          {contracts.map((contract) => (
            <div key={contract.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div>
                <h3 className="font-semibold text-gray-900">{contract.name}</h3>
                <p className="text-sm text-gray-500">Created: {contract.createdDate}</p>
              </div>
              <div className="flex items-center space-x-4">
                {getStatusBadge(contract.status)}
                <button className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md text-sm">
                  {t('viewContract')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EContractView;
